export default "__VITE_ASSET__EgGp9rwN__"